import { render, staticRenderFns } from "./contractInstall-list.vue?vue&type=template&id=61ff5178"
import script from "./contractInstall-list.vue?vue&type=script&lang=js"
export * from "./contractInstall-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports